import React from "react";
import { QqControlPropsType } from "./qq-control-props.type";
import { OptionValueModel } from "../model/option-value.model";
import { DropdownControlSettingsModel } from "../model/dropdown-control.settings.model";
import { dropdownAction } from "../message-interop/control-actions/dropdown.action";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { QqQuizControlContainerComponent } from "./qq-quiz-control-container.component";
import { ControlTitleTypography } from "./qq-typohraphy.controls";
import { styled } from "@mui/material/styles";

const StyledSelect = styled(Select)(({ theme }) => ({
  width: "100%",
  fontSize: "13px",
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "13px",
  paddingBottom: "6px",
  paddingTop: "6px",
}));

export const QqDropdownControl: React.FunctionComponent<
  QqControlPropsType<DropdownControlSettingsModel, OptionValueModel>
> = ({ qq, settings, dispatch, state }) => {
  if (qq.visible !== undefined && !qq.visible) return <span />;

  const selectedValue = state.ctrlPos[qq.key];

  return (
    <QqQuizControlContainerComponent>
      <ControlTitleTypography>{qq.text}</ControlTitleTypography>
      <StyledSelect
        value={selectedValue ?? ""}
        name={`${qq.key}`}
        id={`${qq.key}`}
        size={"small"}
        onChange={(e) => dispatch(dropdownAction(qq, e.target.value as string))}
      >
        {settings.values.map((v, index) => (
          <StyledMenuItem key={index} value={v}>
            {v}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </QqQuizControlContainerComponent>
  );
};
